export class Video {
  constructor(trigger) {
    if (!trigger) return;
    const component = trigger.closest('.js-c-video');
    const holder = component?.querySelector('.c-video__holder');
    trigger.addEventListener('click', e => {
      e.preventDefault();
      component.classList.add('is-active');
      holder?.addEventListener('transitionend', () => {
        const iframe = holder.querySelector('iframe');
        if (iframe) iframe.src += '&autoplay=1';
      }, { once: true });
    });
  }
}
